
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.439 40H8.56C3.841 40 0 36.159 0 31.439V8.56C0 3.841 3.841 0 8.561 0H31.44C36.159 0 40 3.841 40 8.561V31.44C40 36.159 36.159 40 31.439 40zM8.56 1.557A7.012 7.012 0 001.557 8.56V31.44a7.012 7.012 0 007.004 7.004H31.44a7.012 7.012 0 007.004-7.004V8.56a7.012 7.012 0 00-7.004-7.004H8.56z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.458 18.329c5.906-2.573 9.843-4.27 11.813-5.089 5.626-2.34 6.795-2.746 7.557-2.76.167-.003.542.04.785.236.205.166.261.391.289.55.027.158.06.516.034.797-.305 3.203-1.624 10.976-2.296 14.564-.284 1.518-.843 2.027-1.384 2.077-1.177.108-2.07-.778-3.209-1.524-1.783-1.17-2.79-1.896-4.52-3.037-2-1.318-.704-2.043.436-3.227.298-.31 5.48-5.024 5.581-5.452.012-.053.024-.252-.094-.358-.119-.105-.293-.069-.42-.04-.179.04-3.027 1.923-8.545 5.648-.808.555-1.54.826-2.196.811-.724-.015-2.115-.409-3.15-.745-1.268-.412-2.276-.63-2.188-1.33.045-.365.548-.738 1.506-1.12l.001-.001z","fill":"#fff"}})])
          )
        }
      }
    